import { entityDetail } from '../../service'
import {one_option, two_option ,three_option} from './chart_options'
import filter from 'js/filter'
import moment from 'moment'

const mixin_echart = {
  data() {
    let current_year = moment().format('YYYY')
    let temp_arr_year = []
    for(let i = 2010; i <= current_year; i++) {
      temp_arr_year.push(i+'')
    }

    return {
      years: [...temp_arr_year].reverse(),
      years_2: temp_arr_year,
      mouths: ['01','02','03','04','05','06','07','08','09','10','11','12'],
      params_tzfx: {
        uid: this.$route.params.uid,
        type: 'tzfx',
        year: '',
        entity_type: 1
      },
      tzfx: [],
      tzfx_list: [],
      one_option: one_option,
      two_option: two_option,
      three_option1: three_option,
      three_option2: three_option,
      three_option3: three_option,
      three_option4: three_option,
      echarts_1: true,
      echarts_2: true,
      echarts_3: true,
      echarts_4: true,
      echarts_5: true,
      echarts_6: true,
      map_event: [],
      map_round: [],
      tag_map: '',
      total: 0
    }
  },
  computed: {
    theme_switch() {
      return this.$store.state.theme_switch
    },
    dynview_tag_fisrt() {
      let dynview_tag = this.$store.state.dynview_tag
      let dynview_tag_array_1 = []
      dynview_tag.map((a) => {
        if(a.pid == null) {
          dynview_tag_array_1.push(a)
        }
      })
      return dynview_tag_array_1
    },
    check_data() {
      return function(arr) {
        var a = arr.findIndex((b) => {
          return b != 0
        })
        if(a == -1){
          return false
        }else{
          return true
        }
      }
    },
    check_data2() {
      return function(arr) {
        var a = arr.findIndex((b) => {
          return b.value != 0
        })
        if(a == -1){
          return false
        }else{
          return true
        }
      }
    }
  },
  methods: {
    async initCharts() {
      // console.log(this.params_tzfx)
      let res = await entityDetail(this.params_tzfx, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$set(this.$data, 'tzfx', res.tzlist)
        this.$set(this.$data, 'tzfx_list', [...res.tzlist].slice(0,10))
        this.total = res.tzlist.length
        this.$set(this.$data, 'map_event', res.map_event)
        this.$set(this.$data, 'map_round', res.map_round)
        this.tag_map = res.tag_map
      } else {
        this.$Message.error(res.msg)
      }

      let event_num_arr = [],amount_arr = []

      var chart1 = echarts.init(document.getElementById('chart1'),'macarons')
      if(!this.params_tzfx.year){
        this.years_2.map((a) => {
          let index = this.map_event.findIndex((b) => {return a == b.years})
          if(index > -1){
            event_num_arr.push(this.map_event[index].event_num)
            amount_arr.push(this.map_event[index].dollar_amount)
          }else{
            event_num_arr.push('0')
            amount_arr.push('0')
          }
        })
        this.one_option.xAxis[0].data = this.years_2
      }else{
        this.mouths.map((a) => {
          let index = this.map_event.findIndex((b) => {return a == b.years})
          if(index > -1){
            event_num_arr.push(this.map_event[index].event_num)
            amount_arr.push(this.map_event[index].dollar_amount)
          }else{
            event_num_arr.push('0')
            amount_arr.push('0')
          }
        })
        this.one_option.xAxis[0].data = this.mouths
      }
      this.one_option.series[0].data = event_num_arr
      this.one_option.series[1].data = amount_arr
      // console.log(event_num_arr)
      // console.log(amount_arr)

      var chart2 = echarts.init(document.getElementById('chart2'),'macarons')
      let temp = [],x_round_arr = []
      this.map_round.map((a) => {
        temp.push({
          name: a.round_id ? filter.deal(a.round_id, 'round') : '并购',
          value: a.count
        })
        x_round_arr.push(a.round_id ? filter.deal(a.round_id, 'round') : '并购')
      })
      this.two_option.legend.data = x_round_arr
      this.two_option.series[0].data = temp

      this.echartChangeTheme()

      chart1.setOption(this.one_option)
      chart2.setOption(this.two_option)

      // let type_arr_1_x = [], type_arr_2_x = [], type_arr_3_x = [], type_arr_4_x = [],
      //     type_arr_1_y = [], type_arr_2_y = [], type_arr_3_y = [], type_arr_4_y = []

      // // console.log('dynview_tag_fisrt', this.dynview_tag_fisrt)

      // this.dynview_tag_fisrt.map((a) => {
      //   if(a.type_id == '1') type_arr_1_x.push(a.name)
      //   if(a.type_id == '2') type_arr_2_x.push(a.name)
      //   if(a.type_id == '3') type_arr_3_x.push(a.name)
      //   if(a.type_id == '4') type_arr_4_x.push(a.name)
      // })
      // // console.log('tag_map', this.tag_map)

      // let tag_map_arr = []
      // for (var prop in this.tag_map) {
      //   tag_map_arr.push(this.tag_map[prop])
      // }

      // // console.log('tag_map_arr', tag_map_arr)

      // let tag_map_arr_1 = [], tag_map_arr_2 = [], tag_map_arr_3 = [], tag_map_arr_4 = []

      // for (var prop in tag_map_arr[0]) {
      //   tag_map_arr_1.push({
      //     name: prop,
      //     count: tag_map_arr[0][prop]
      //   })
      // }

      // for (var prop in tag_map_arr[1]) {
      //   tag_map_arr_2.push({
      //     name: prop,
      //     count: tag_map_arr[1][prop]
      //   })
      // }

      // for (var prop in tag_map_arr[2]) {
      //   tag_map_arr_3.push({
      //     name: prop,
      //     count: tag_map_arr[2][prop]
      //   })
      // }

      // for (var prop in tag_map_arr[3]) {
      //   tag_map_arr_4.push({
      //     name: prop,
      //     count: tag_map_arr[3][prop]
      //   })
      // }

      // // console.log('tag_map_arr_1', tag_map_arr_1)
      // // console.log('tag_map_arr_2', tag_map_arr_2)
      // // console.log('tag_map_arr_3', tag_map_arr_3)
      // // console.log('tag_map_arr_4', tag_map_arr_4)

      // type_arr_1_x.map((a) => {
      //   // console.log(a)
      //   let idx = tag_map_arr_1.findIndex((b)=> b.name == a)
      //   if(idx > -1){
      //     type_arr_1_y.push(tag_map_arr_1[idx].count)
      //   }else{
      //     type_arr_1_y.push(0)
      //   }
      // })

      // type_arr_2_x.map((a) => {
      //   // console.log(a)
      //   let idx = tag_map_arr_2.findIndex((b)=> b.name == a)
      //   if(idx > -1){
      //     type_arr_2_y.push(tag_map_arr_2[idx].count)
      //   }else{
      //     type_arr_2_y.push(0)
      //   }
      // })

      // type_arr_3_x.map((a) => {
      //   // console.log(a)
      //   let idx = tag_map_arr_3.findIndex((b)=> b.name == a)
      //   if(idx > -1){
      //     type_arr_3_y.push(tag_map_arr_3[idx].count)
      //   }else{
      //     type_arr_3_y.push(0)
      //   }
      // })

      // type_arr_4_x.map((a) => {
      //   // console.log(a)
      //   let idx = tag_map_arr_4.findIndex((b)=> b.name == a)
      //   if(idx > -1){
      //     type_arr_4_y.push(tag_map_arr_4[idx].count)
      //   }else{
      //     type_arr_4_y.push(0)
      //   }
      // })

      // var chart3 = echarts.init(document.getElementById('chart3'),'macarons')
      // this.three_option1.title.text = '机构当前布局情况（产业链）'
      // this.three_option1.xAxis[0].data = type_arr_1_x
      // this.three_option1.series[0].data = type_arr_1_y
      // chart3.setOption(this.three_option1)

      // var chart4 = echarts.init(document.getElementById('chart4'),'macarons')
      // this.three_option2.title.text = '机构当前布局情况（技术）'
      // this.three_option2.xAxis[0].data = type_arr_2_x
      // this.three_option2.series[0].data = type_arr_2_y
      // chart4.setOption(this.three_option2)

      // var chart5 = echarts.init(document.getElementById('chart5'),'macarons')
      // this.three_option3.title.text = '机构当前布局情况（概念）'
      // this.three_option3.xAxis[0].data = type_arr_3_x
      // this.three_option3.series[0].data = type_arr_3_y
      // chart5.setOption(this.three_option3)

      // var chart6 = echarts.init(document.getElementById('chart6'),'macarons')
      // this.three_option3.title.text = '机构当前布局情况（应用场景）'
      // this.three_option4.xAxis[0].data = type_arr_4_x
      // this.three_option4.series[0].data = type_arr_4_y
      // chart6.setOption(this.three_option4)

      if(!this.check_data(event_num_arr) && !this.check_data(amount_arr)){
        this.echarts_1 = false
      }else{
        this.echarts_1 = true
      }
      this.echarts_2 = this.check_data2(temp)
      // this.echarts_3 = this.check_data(type_arr_1_y)
      // this.echarts_4 = this.check_data(type_arr_2_y)
      // this.echarts_5 = this.check_data(type_arr_3_y)
      // this.echarts_6 = this.check_data(type_arr_4_y)
    },
    handlePage(page) {
      this.$set(this.$data, 'tzfx_list', [...this.tzfx].slice(10*(page-1),10*page))
    },
    handleYears() {
      this.initCharts()
    },
    echartChangeTheme() {
      this.one_option.backgroundColor = this.theme_switch ? '#FFFFFF' : '#2A2F42'
      this.one_option.title.textStyle.color = this.theme_switch ? '#333333' : '#E9E9EB'
      this.one_option.legend.textStyle.color = this.theme_switch ? '#333333' : '#E9E9EB'
      this.one_option.yAxis[1].splitLine.lineStyle.color = this.theme_switch ? '#E9E9EB' : '#40444F'
      this.one_option.xAxis[0].axisLine.lineStyle.color = this.theme_switch ? '#E9E9EB' : '#40444F'

      this.two_option.backgroundColor = this.theme_switch ? '#FFFFFF' : '#2A2F42'
      this.two_option.title.textStyle.color = this.theme_switch ? '#333333' : '#E9E9EB'
      this.two_option.legend.textStyle.color = this.theme_switch ? '#333333' : '#E9E9EB'
    }
  },
  watch: {
    uid(val) {
      this.initCharts()
    },
    theme_switch(val) {
      var chart1 = echarts.init(document.getElementById('chart1'),'macarons')
      var chart2 = echarts.init(document.getElementById('chart2'),'macarons')
      this.echartChangeTheme()
      chart1.setOption(this.one_option)
      chart2.setOption(this.two_option)
    }
  }
}

export { mixin_echart }
